<template>
  <div class="app-container">
    <router-view />
  </div>
</template>
<script>
// export default {
//   name: "App",
//   mounted() {
//     this.setAppWidth();
//     window.addEventListener("resize", this.setAppWidth);
//   },
//   beforeDestroy() {
//     window.removeEventListener("resize", this.setAppWidth);
//   },
//   methods: {
//     setAppWidth() {
//       const appContainer = document.querySelector(".app-container");
//       const screenWidth = window.innerWidth;
//       if (screenWidth > 500) {
//         appContainer.style.width = "500px";
//       } else {
//         appContainer.style.width = "100%";
//       }
//     },
//   },
// };
</script>
<style>
body {
  background: #fafafa;
}
/* 设置最大宽度为 500px 的样式 */
.app-container {
  max-width: 500px;
  margin: 0 auto;
  width: 100%;
}

/* 如果屏幕宽度小于 500px，自适应全屏 */
@media (max-width: 500px) {
  .app-container {
    width: 100%;
  }
}
</style>

